package top.wcpe.allincore.dsl.compiler.ast

import top.wcpe.allincore.dsl.compiler.source.SourcePosition

/**
 * M5-c：类型标注 AST。
 *
 * 用于 `var x: Type = expr` 等语法位置承载用户书写的类型形态。
 * 第一版仅作语法承载与语义占位；不做泛型实例化检查、协变/逆变与类型推断回填。
 */
sealed class TypeAst {
    abstract val position: SourcePosition

    /** 简单命名类型：Int, String, Bool, Boolean, Number, Any, Unit。 */
    data class Named(
        val name: String,
        val nullable: Boolean,
        override val position: SourcePosition,
    ) : TypeAst()

    /** 泛型类型：List<T>, Map<K, V>。第一版仅作语法承载。 */
    data class Generic(
        val name: String,
        val args: List<TypeAst>,
        val nullable: Boolean,
        override val position: SourcePosition,
    ) : TypeAst()

    /** 函数类型：(T1, T2) -> R / suspend (T) -> R。M5-d 才会实际消费。 */
    data class Function(
        val params: List<TypeAst>,
        val ret: TypeAst,
        val isSuspend: Boolean,
        val nullable: Boolean,
        override val position: SourcePosition,
    ) : TypeAst()
}

/** 诊断消息用展示名，支持泛型完整签名与可空后缀。 */
fun TypeAst.displayName(): String = when (this) {
    is TypeAst.Named -> if (nullable) "$name?" else name
    is TypeAst.Generic -> {
        val base = if (args.isNotEmpty()) {
            "$name<${args.joinToString(",") { it.displayName() }}>"
        } else {
            name
        }
        if (nullable) "$base?" else base
    }
    is TypeAst.Function -> "(..)->.."
}
